import { Component } from "vue-property-decorator"

import FuzzySearchBase from "./fuzzySearch.client.base"

@Component
export default class FuzzySearchWeb extends FuzzySearchBase {}
